import { defineStore } from "pinia";
import { ref } from "vue";
import { api, getToken, setToken } from "../api";
import { clearAttachmentImageCache } from "../attachmentImageCache";
import { readableError } from "../composables/format";
import type { User, UserSettingsPatch } from "../types";

export const useAuthStore = defineStore("auth", () => {
  const user = ref<User | null>(null);
  const notice = ref("");
  const booted = ref(false);

  async function boot() {
    if (booted.value) return;
    booted.value = true;
    if (!getToken()) return;
    try {
      const response = await api.me();
      user.value = response.user;
      notice.value = "";
    } catch (error) {
      clearAttachmentImageCache();
      setToken(null);
      user.value = null;
      notice.value = readableError(error);
    }
  }

  async function login(email: string, password: string) {
    const response = await api.login(email, password);
    clearAttachmentImageCache();
    setToken(response.token);
    user.value = response.user;
    notice.value = "";
    return response.user;
  }

  async function register(email: string, password: string) {
    const response = await api.register(email, password);
    clearAttachmentImageCache();
    setToken(response.token);
    user.value = response.user;
    notice.value = "";
    return response.user;
  }

  function logout() {
    clearAttachmentImageCache();
    setToken(null);
    user.value = null;
    notice.value = "";
  }

  async function updateSettings(payload: UserSettingsPatch) {
    const response = await api.settings(payload);
    user.value = response.user;
    return response.user;
  }

  return {
    user,
    notice,
    boot,
    login,
    register,
    logout,
    updateSettings
  };
});
